import { h, Component } from 'preact';
import { observer } from 'mobx-preact';
import { Text } from 'preact-i18n';
import { route } from 'preact-router';

import { unopenedCount, countdownText } from '../../lib/adventCalendar';

/**
 * Frontpage card for the club advent calendar: «Door N is open» with a link to /julekalender.
 * Rendered by routes/frontpage/loggedIn.js for shooting clubs in December; renders nothing when
 * the calendar is closed.
 */
@observer
class AdventCalendarCard extends Component {
    componentDidMount() {
        const { adventCalendarStore } = this.props.stores;
        if (!adventCalendarStore.view) {
            adventCalendarStore.loadView();
        }
    }

    go = () => {
        route('/julekalender');
    }

    render() {
        const { adventCalendarStore } = this.props.stores;
        const { view } = adventCalendarStore;
        if (!view) {
            return null;
        }
        if (view.state === 'closed') {
            // November: countdown and the reminder sign-up (waiting page).
            if (!view.waiting?.showWaiting) {
                return null;
            }
            const reminderSet = !!(view.reminder?.email || view.reminder?.push);
            return (
                <div class='card mb-3 border-success'>
                    <div class='card-body d-flex align-items-center gap-3 py-2'>
                        <span style='font-size: 2rem; line-height: 1;'>🎄</span>
                        <div class='flex-grow-1'>
                            <div class='fw-bold'>{view.title || `Julekalender ${view.year}`}</div>
                            <div class='small text-body-secondary'>
                                {countdownText(view.waiting.daysLeft)}
                                {reminderSet ? (
                                    <span> · <Text id='adventCalendar.cardReminderSet'>You get a message when it opens ✓</Text></span>
                                ) : null}
                            </div>
                        </div>
                        {reminderSet ? null : (
                            <button type='button' class='btn btn-sm btn-success' onClick={this.go}>
                                <Text id='adventCalendar.cardSignup'>Get a message</Text>
                            </button>
                        )}
                    </div>
                </div>
            );
        }
        const waiting = unopenedCount(view.doors || []);
        return (
            <div class='card mb-3 border-success'>
                <div class='card-body d-flex align-items-center gap-3 py-2'>
                    <span style='font-size: 2rem; line-height: 1;'>🎁</span>
                    <div class='flex-grow-1'>
                        <div class='fw-bold'>{view.title}</div>
                        <div class='small text-body-secondary'>
                            {waiting > 0 ? (
                                <Text id='adventCalendar.cardWaiting' fields={{ count: waiting }}>{waiting} doors are waiting for you</Text>
                            ) : (
                                <Text id='adventCalendar.cardAllOpened' fields={{ day: view.today }}>Door {view.today} is open</Text>
                            )}
                        </div>
                    </div>
                    <button type='button' class='btn btn-success btn-sm' onClick={this.go}>
                        <Text id='adventCalendar.cardOpen'>Open</Text>
                    </button>
                </div>
            </div>
        );
    }
}

export default AdventCalendarCard;
